export const LINQ_ADDRESS = {
  name: 'Linq',
  line1: '1904 1st Ave N',
  line2: 'Suite 200',
  city: 'Birmingham',
  state: 'Alabama',
  postal_code: '35203',
  country: 'United States',
  email: 'contact@linqapp.com',
}
